import { Navigate, Outlet, RouterProvider, createBrowserRouter } from "react-router";

import { CognitoCallbackLogoutPage, CognitoCallbackPage } from "@nens/ranalib";
import { ScrollToTop } from "@nens/react/components";
import { SentryErrorBoundary } from "@nens/sentry";

import { LoginPage } from "@/lib/auth";
import { isLocalhostEnvironment } from "@/utils/is-test-environment";

import { TenantRoutes, tenantRouteObjects } from "./tenant-routes";

export function AppRoutes() {
  /* Note that the invitation accept page is per-tenant but for as yet
     unauthorised users. So place it outside the TenantProvider. */

  function RootLayout() {
    return (
      <>
        <ScrollToTop />
        <Outlet />
      </>
    );
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <SentryErrorBoundary appName="rana" theme="rana">
          <RootLayout />
        </SentryErrorBoundary>
      ),
      children: [
        // "/pricing" goes to the io pricing page. But "/pricing/" (with trailing slash) would not, so we remove the trailing slash in the link
        {
          path: "pricing",
          element: <Navigate to="/pricing" />,
        },
        { path: "auth/callback/cognito", element: <CognitoCallbackPage /> },
        { path: "auth/callback/cognito/logout", element: <CognitoCallbackLogoutPage /> },
        isLocalhostEnvironment()
          ? {
              path: "",
              element: <Navigate to="/nenstest" />,
            }
          : {},
        { path: "login", element: <LoginPage /> },
        {
          path: ":tenant/*",
          element: (
            <TenantRoutes>
              <Outlet />
            </TenantRoutes>
          ),
          children: tenantRouteObjects,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}
